import React from 'react';
import styled from 'styled-components';

const TableButton = ( { type, text, actionHandler }: any ) => {

    return (

        <TableButtonWrapper>
            <button className = { type } onClick = { actionHandler } >{ text }</button>            
        </TableButtonWrapper>
    )
}

const TableButtonWrapper = styled.div`

    button {
        background: transparent;
        border: none;
        outline: none;
        font-size: 16px;
    }
    .red {
        background: red;
        color: white;
    }
    .green {
        background: green;
        color: white;
    }
    .red, .green, .normal, .blue {
        border: 1px solid black;
        font-weight: bolder;
        padding: 6px 14px;
    }
    .blue {
        background: #0a4369;
        color: white;

    }

`

export default TableButton;
